/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsstart2Inputs */

const en_ticketspayoutsstart2 = /** @type {(inputs: Ticketspayoutsstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up with Stripe`)
};

const de_ticketspayoutsstart2 = /** @type {(inputs: Ticketspayoutsstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Stripe einrichten`)
};

/**
* | output |
* | --- |
* | "Set up with Stripe" |
*
* @param {Ticketspayoutsstart2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsstart2 = /** @type {((inputs?: Ticketspayoutsstart2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsstart2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsstart2(inputs)
	return de_ticketspayoutsstart2(inputs)
});
export { ticketspayoutsstart2 as "ticketsPayoutsStart" }